module.exports = __webpack_public_path__ + "static/media/warn.fa659ce9.png";